export default __webpack_public_path__ + "static/main-video-65dba68f175dbeb31c4f39a784865463.webm";